import { HTTP } from '../../utils/http';
import { PaginationParams } from '../../utils/pagination-params';

export const LocationsService = {

    getLocations(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`schools/${schoolId}/settings/locations`);
        return HTTP.get(url);
    },

    getAllLocations(schoolId) {
        return HTTP.get(`schools/${schoolId}/settings/locations/simple-list`);
    },

    getLocation(schoolId, locationId) {
        return HTTP.get(`schools/${schoolId}/settings/locations/${locationId}`);
    },

    addLocation(schoolId, form) {
        return HTTP.post(`schools/${schoolId}/settings/locations`, form);
    },

    addLocationsBulk(schoolId, file) {
        const formData = new FormData();
        formData.append('locations-file', file);
        const headers = {'Content-Type': 'multipart/form-data'};
        return HTTP.post(`schools/${schoolId}/settings/locations/csv-import`, formData, { headers });
    },

    editLocation(schoolId, locationId, form) {
        return HTTP.patch(`schools/${schoolId}/settings/locations/${locationId}`, form);
    },

    deleteLocation(schoolId, locationId) {
        return HTTP.delete(`schools/${schoolId}/settings/locations/${locationId}`);
    },

    deleteMultipleLocations(schoolId, locationIds) {
        return HTTP.delete(`schools/${schoolId}/settings/locations/?ids=${locationIds}`);
    },

    toggleLocationStatus(schoolId, locationId) {
        return HTTP.patch(`schools/${schoolId}/settings/locations/${locationId}/status`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/locations.service.js